import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ProjectFilesTreeItemPreviewModule } from '@portal-core/project-files/components/project-files-tree-item-preview/project-files-tree-item-preview.module';
import { ProjectFilesAddSnippetDialogComponent } from './project-files-add-snippet-dialog.component';

@NgModule({
  declarations: [
    ProjectFilesAddSnippetDialogComponent
  ],
  imports: [
    CommonModule,
    ProjectFilesTreeItemPreviewModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatToolbarModule
  ],
  exports: [
    ProjectFilesAddSnippetDialogComponent
  ]
})
export class ProjectFilesAddSnippetDialogModule { }
